module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-header-section"
  }, [_c('div', {
    staticClass: "block-header-section__container"
  }, [_c('div', {
    staticClass: "block-header-section__bg"
  }, [_c('div', {
    staticClass: "block-header-section__left"
  }, [(_vm.props.title) ? _c('div', {
    staticClass: "block-header-section__title"
  }, [_vm._t("header", null, {
    "content": _vm.props.title
  })], 2) : _vm._e(), (_vm.props.subtitle) ? _c('div', {
    staticClass: "block-header-section__subtitle"
  }, [_vm._t("subheader", null, {
    "content": _vm.props.subtitle
  })], 2) : _vm._e()]), _c('div', {
    staticClass: "block-header-section__right"
  }, [(_vm.props.body) ? _c('div', {
    staticClass: "block-header-section__body"
  }, [_vm._t("body", null, {
    "content": _vm.props.body
  })], 2) : _vm._e(), (_vm.props.image) ? _c('div', {
    staticClass: "block-header-section__image"
  }, [_vm._t("image", null, {
    "content": _vm.props.image
  })], 2) : _vm._e(), (_vm.props.button) ? _c('div', {
    staticClass: "block-header-section__button"
  }, [_vm._t("button", null, {
    "content": _vm.props.button
  })], 2) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63c89d5d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-header-section/block-header-section.pug
// module id = 595
// module chunks = 1